// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","actionBlack":"#2e2e2e","customWhite":"#ffffff","customGrey":"#4b4b4b","footerGrey":"#c0c0c0","borderGrey":"#d5dfdf","customBlackLt":"#202020","alert":"_38YxddQXSSNyqQDQ524FzA"};


//////////////////
// WEBPACK FOOTER
// ./src/common/alert-zone/AlertZone.css
// module id = 427
// module chunks = 0 1 2